// Backend serializes `created_at` as a naive UTC ISO string (no trailing
// `Z`), so a bare `new Date(iso)` is interpreted as local time and yields
// "future" relative ages (`-Xs ago`). Append `Z` when the string carries
// no timezone designator so the Date is anchored to UTC, then render in
// the viewer's locale.
export function formatLocalDateTime(iso: string): string {
  const hasTz = /Z$|[+-]\d{2}:?\d{2}$/.test(iso)
  const date = new Date(hasTz ? iso : iso + 'Z')
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleString()
}
